module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ThematicTransitView.js"));
	}, "ThematicTransitView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThematicTransitView!./src/pages/Learn/Thematic/ThematicTransit/ThematicTransitView.js
// module id = 1234
// module chunks = 438